import React from "react";
import NotificationsSystem, {
  atalhoTheme,
  useNotifications,
  setUpNotifications,
} from "reapop";
import { NextUIProvider, styled } from "@nextui-org/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Container } from "@nextui-org/react";
// import history from "./historyNavigation.js";
import Login from "../auth/Login";
import DevHome from "../dev/home";
import HeaderDev from "../dev/header";
import PlayGround from "../dev/Playground";
import Logs from "../dev/Logs";

setUpNotifications({
  defaultProps: {
    position: "top-right",
    dismissible: true,
    dismissAfter: 2000,
  },
});

const Box = styled("div", {
  boxSizing: "border-box",
});

const Layout = ({ children }) => {
  const { notifications, dismissNotification } = useNotifications();

  return (
    <Box>
      <Login />
      <HeaderDev />
      <div className="content" style={{ marginTop: 40 }}>
        <Container md>{children}</Container>
      </div>
      <NotificationsSystem
        // 2. Pass the notifications you want Reapop to display.
        notifications={notifications}
        // 3. Pass the function used to dismiss a notification.
        dismissNotification={(id) => dismissNotification(id)}
        // 4. Pass a builtIn theme or a custom theme.
        theme={atalhoTheme}
      />
    </Box>
  );
};

const Navigation = () => {
  return (
    <NextUIProvider>
      <Router>
        <Layout>
          <Routes>
            <Route
              exact
              path="/"
              element={
                <div>
                  <DevHome />
                </div>
              }
            />
            <Route
              exact
              path="/dev/lists"
              element={
                <div>
                  <DevHome />
                </div>
              }
            />
            <Route exact path="/dev/playground" element={<PlayGround />} />
            <Route
              exact
              path="/dev/logs"
              element={
                <div>
                  <Logs />
                </div>
              }
            />
            <Route path="*" element={<div>PAGE NOT FOUND!</div>} />
          </Routes>
        </Layout>
      </Router>
    </NextUIProvider>
  );
};

export default Navigation;
